<script>
import FAQQuestion from '@/components/FAQQuestion.vue'
import { mvpFAQ } from '@/data/faqdata'

export default {
  name: 'FAQComponent',
  data() {
    return {
      faqs: mvpFAQ,
    }
  },
  components: {
    FAQQuestion,
  },
}
</script>

<template>
  <v-container fluid fill-width class="inset faqcontainer">
    <v-row>
      <v-col cols="12">
        <v-expansion-panels flat>
          <FAQQuestion
            v-for="(faq, i) in faqs"
            :key="i"
            :question="faq.question"
            :answer="faq.answer"
          />
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
.faqheader {
  text-align:center;
  margin: 0 auto;
  width: 50%;
}

@media only screen and (max-width: 960px) {
  .faqheader {
    width: 100%;
  }
}
</style>
